import { advanceTask } from './advanceTask'
import { jobLogger } from './jobLogger-sidecar'
import { IJob, registerJob } from './jobs'
import { createTask_takeOffSuit } from './taskTakeOffSuit'

export const register = () => registerJob('take-off-suit', advanceJob)

function advanceJob(job: IJob) {
  jobLogger.assertJobType(job, 'take-off-suit')
  let m = jobLogger.assertReserved(job)

  // Seed job tasks
  if (job.tasks.length === 0) {
    job.tasks = []
    let task = createTask_takeOffSuit(m.i, m.j)
    job.tasks.push(task)
    return
  }

  if (job.tasks.length > 0) {
    advanceTask(job)
  }
}
